import "./PersonalInfoConfirmationModal.scss";
import { Form, message, Modal } from "antd";
import { useSelector } from "react-redux";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import InfoText from "../../../commonComponents/InfoText/InfoText";
import MultipleInputs from "./MultipleInputs";
import { useAuth } from "../../../../authentication/authHelpers";
import { useMemo, useState } from "react";
import RenderDynamicComponents from "../../../RenderDynamicComponents/RenderDynamicComponents";
import fieldsJSON from "./fieldsJSON";
import dayjsTZ from "../../../../utils/dayjs";
import { API } from "aws-amplify";
import { notificationUserToAdmin } from "../../../../utils/sendNotification";

const PersonalInfoConfirmationModal = ({ open, setOpen }) => {
  const [form] = Form.useForm();
  const { employee, user } = useAuth();

  const { isDarkMode } = useSelector((state) => state.usersList);

  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    if (!employee?.employeeId) {
      message.error("Dicka shkoi gabim! Kontaktoni supervizorin tuaj.");
      setOpen(false);
      return;
    }
    setLoading(true);
    form
      .validateFields()
      .then(async (values) => {
        await API.put("employees", `/employees/${employee?.employeeId}`, {
          body: {
            dataVerification: {
              isVerified: true,
              verifiedAt: dayjsTZ().valueOf(),
              verifiedBy: employee?.employeeEmailWork,
              verifiedFields: values,
            },
            keylog: [
              ...(employee?.keylog || []),
              {
                activity: "Ndryshuar",
                author: user?.given_name + " " + user?.family_name,
                changeDate: dayjsTZ().valueOf(),
                oldValue: "",
                newValue: "Konfirmoi të dhënat personale",
              },
            ],
          },
        })
          .then((res) => {
            const notifBody = {
              notificationTitle: "Konfirmim i të dhënave personale",
              notificationBody: `Punonjësi ${
                employee?.employeeFirstName + " " + employee?.employeeLastName
              } konfirmoi të dhënat e tij/saj personale.`,
              notificationUrl: `/punonjesit/specifikat/${employee?.employeeId}`,
              createdAt: dayjsTZ().format("DD/MM/YYYY"),
              notificationPriority: false,
              notificationCategory: "Info",
              isAnnouncement: false,
              notificationFirstName: user?.given_name,
              notificationLastName: user?.family_name,
            };
            notificationUserToAdmin(notifBody, user?.allUsers?.Items || []);
            setOpen(false);
            form.resetFields();
            message.success("Faleminderit për kohën tuaj!");
          })
          .catch((err) => console.log("err: ", err))
          .finally(() => setLoading(false));
      })
      .catch((error) => {
        setLoading(false);
        message.error("Ju lutem plotësoni të gjitha fushat e detyrueshme!");
      });
  };

  const currentValue = useMemo(() => {
    if (!employee) return null;

    let currentValue = employee?.employeeEmergencyContact;
    if (typeof currentValue === "string") {
      currentValue = {
        fullName: "",
        email: "",
        phoneNumber: employee?.employeeEmergencyContact,
        relationship: "",
      };
    }
    for (const field of fieldsJSON) {
      const val = employee[field.formItemName];
      if (!val) continue;
      const toSet =
        field?.type === "datepicker" || field?.type === "timepicker"
          ? dayjsTZ(val)
          : val;
      form.setFieldValue(field.formItemName, toSet);
    }

    return currentValue;
  }, [employee, form]);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      centered
      className={`personalInfoConfirmationModal ${
        isDarkMode ? "dark darkHeader" : "lightHeader"
      }`}
      footer={[
        <MondayButton
          className="mondayButtonGreen"
          onClick={handleConfirm}
          spin={loading}
        >
          Konfirmo
        </MondayButton>,
      ]}
      title={"Konfirmo të dhënat e tua personale"}
      destroyOnClose={true}
      closeIcon={false}
    >
      <InfoText
        text={
          "Këto janë të dhënat e tua personale të ruajtura në portal. Ju lutem konfirmoni këto të dhëna dhe të tjera që mund të mungojnë. Kujtesë që këto të dhëna janë të mbrojtura dhe do të përdoren vetëm për qëllime të brendshme."
        }
      />
      <Form form={form}>
        <div className="confirmationModalContent">
          <div className="personalInfo">
            {RenderDynamicComponents(fieldsJSON, form)}
          </div>

          <MultipleInputs
            {...{
              form: form,
              name: "employeeEmergencyContact",
              value: currentValue,
              label: "Kontakt emergjence",
              type: "MultipleInputs",
              disabled: false,
              dynamicFields: [
                {
                  formItemName: "fullName",
                  label: "Emri i plotë",
                  placeholder: "Emri i plotë",
                  type: "Input",
                  disabled: false,
                  rules: [
                    {
                      required: true,
                      message: "Ju lutem shkruani emrin e plotë",
                    },
                  ],
                },
                {
                  formItemName: "email",
                  label: "Email",
                  type: "Email",
                  disabled: false,
                  rules: [
                    {
                      required: true,
                      type: "email",
                      message: "Formati i email nuk është i saktë!",
                    },
                  ],
                },
                {
                  formItemName: "phoneNumber",
                  label: "Numri i telefonit",
                  type: "PhoneNumber",
                  rules: [
                    {
                      required: true,
                      message: "Ju lutem shkruani numrin e telefonit!",
                    },
                  ],
                  disabled: false,
                },
                {
                  formItemName: "relationship",
                  label: "Lidhja me personin",
                  type: "ComboBox",
                  options: [
                    "Prindi",
                    "Bashkëshorti/ja",
                    "Motra/Vëllai",
                    "Fëmija",
                    "Mik/Mikeshë",
                  ],
                  disabled: false,
                  rules: [
                    {
                      required: true,
                      message:
                        "Ju lutem zgjidhni marrëdhënien tuaj me personin",
                    },
                  ],
                },
              ],
            }}
          />
        </div>
      </Form>
    </Modal>
  );
};

export default PersonalInfoConfirmationModal;
